webpackJsonp([19],{

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_influencer_share_link__ = __webpack_require__(28);


var BANNER_TARGET_CLASS = '.js-cpl-banner';
var ITEM_CLASS = '.cpl-banner__cta';
var ACTIVE_CLASS = 'active';
var CPL_ID_PARAM = 'cplid';
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_influencer_share_link__["a" /* default */])();
  var urlParams = new URLSearchParams(window.location.search);
  var cplId = urlParams.get(CPL_ID_PARAM);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(ITEM_CLASS, __WEBPACK_IMPORTED_MODULE_0_jquery___default()(BANNER_TARGET_CLASS)).each(function (i, el) {
    var $anchor = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
    if ($anchor.length) {
      var href = $anchor.attr('href');
      var hrefParts = href ? href.split('?') : [];
      var anchorUrlParams = new URLSearchParams(hrefParts.length === 2 ? '?' + hrefParts[1] : '');
      var anchorCplId = anchorUrlParams.get(CPL_ID_PARAM);
      if (anchorCplId === cplId) {
        $anchor.addClass(ACTIVE_CLASS);
      }
    }
  });
});

/***/ })

},[236]);


// WEBPACK FOOTER //
// dist/cpl.js